import { useTranslation } from 'react-i18next';

/**
 * The `pages` namespace: the application's own chrome — navigation and tab
 * names, page titles, and the copy a page shows that belongs to no feature
 * module. Domain vocabulary stays in the module that owns it, and a page that
 * needs some reaches for that module's hook alongside this one.
 */
export const usePagesTranslation = () => useTranslation('pages');
